import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("rect", {
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 4
}), React.createElement("path", {
  d: "M5.271 13.117L10.1 16.98c.301.24.738.204.994-.084l7.724-8.69a.725.725 0 0 0-1.082-.962l-7.268 8.176-4.291-3.433a.724.724 0 0 0-.905 1.131z",
  fill: "#FFF"
}));

var SvgCheckboxSelected = function SvgCheckboxSelected(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCheckboxSelected;